import SamplePage from "../Pages/SamplePage/SamplePage";
import UsersProfile from "../Pages/Application/Users/UsersProfile/UsersProfile";
import EditProfile from "../Pages/Application/Users/EditProfile/EditProfile";
import UserCards from "../Pages/Application/Users/UserCards/UserCards";
import AddUser from "../Pages/Application/Users/AddUser/AddUser";
import UserEdit from "../Component/Application/Users/EditUser/UserEdit";
import AddBlog from "../Pages/Application/blogs/AddBlog/AddBlog";
import BlogCards from "../Pages/Application/blogs/BlogCards/BlogCards";
import EditBlog from "../Pages/Application/blogs/EditBlog/EditBlog";
import SelfUser from "../Pages/Application/Users/SelfUser/SelfUser";
import SeoAddEdit from "../Pages/Application/blogs/SeoAddEdit/SeoAddEdit";
import TagCards from "../Pages/Application/Tags/TagCards/TagCards";
import AddTag from "../Pages/Application/Tags/AddTag/AddTag";
import CTACards from "../Pages/Application/CTAs/CTACards/CTACards";
import AddCTA from "../Pages/Application/CTAs/AddCTA/AddCTA";
import BlogCTAAssignPage from "../Component/Application/blogs/AddCTA/BlogCTAAssignPage";
import CtaPage from "../Pages/Application/blogs/CtaPage/CtaPage";
export const baseRoutes = [
  { path: `/dashboard`, Component: <SamplePage /> },
  { path: `/blogs/add`, Component: <AddBlog /> },
  { path: `/blogs/cards`, Component: <BlogCards /> },
  { path: `/blogs/cta/:id`, Component: <CtaPage /> },
  { path: `/blogs/seo/:id`, Component: <SeoAddEdit /> },
  { path: `/blogs/edit/:id`, Component: <EditBlog /> },
  { path: `/update-profile`, Component: <SelfUser /> },
  {
    path: `/authors/edit/:id`,
    Component: <UserEdit />,
  },
  { path: `/authors/cards`, Component: <UserCards /> },
  { path: `/authors/add`, Component: <AddUser /> },
  { path: `/tags/cards`, Component: <TagCards /> },
  { path: `/tags/add`, Component: <AddTag /> },
  { path: `/tags/edit/:id`, Component: <AddTag /> },
  { path: `/ctas/cards`, Component: <CTACards /> },
  { path: `/ctas/add`, Component: <AddCTA /> },
  { path: `/ctas/edit/:id`, Component: <AddCTA /> },
];

export const superAdminRoutes = [
  { path: `/users/add`, Component: <AddUser /> },
  {
    path: `/users/edit/:id`,
    Component: <UserEdit />,
  },
  { path: `/users/cards`, Component: <UserCards /> },
];
